(function () {
  if (window.LymphLP) return;

  var observers = [];

  function init() {
    // Every .cta button follows the pack picked in the offer (except the hero one, which scrolls to it).
    var packs = document.getElementById('packs');
    function update() {
      var picked = document.querySelector('#packs input:checked');
      if (!picked) return;
      document.querySelectorAll('.lymph-lp .cta').forEach(function (a) {
        if (a.getAttribute('href') === '#offer') return;
        a.setAttribute('href', picked.getAttribute('data-url'));
      });
    }
    if (packs && !packs.hasAttribute('data-bound')) {
      packs.setAttribute('data-bound', '');
      packs.addEventListener('change', update);
      packs.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }
    update();

    // Sticky bar appears only once the reader has passed the mechanism section.
    observers.forEach(function (o) {
      o.disconnect();
    });
    observers = [];
    var sticky = document.getElementById('sticky');
    var mech = document.getElementById('mechanism');
    var offer = document.getElementById('offer');
    if (sticky && mech && 'IntersectionObserver' in window) {
      var pastMech = false;
      var offerVisible = false;
      var render = function () {
        var show = pastMech && !offerVisible;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var link = sticky.querySelector('a');
        if (link) link.tabIndex = show ? 0 : -1;
      };
      var o1 = new IntersectionObserver(function (e) {
        pastMech = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        render();
      });
      o1.observe(mech);
      observers.push(o1);
      if (offer) {
        var o2 = new IntersectionObserver(function (e) {
          offerVisible = e[0].isIntersecting;
          render();
        });
        o2.observe(offer);
        observers.push(o2);
      }
    }
  }

  window.LymphLP = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
